export default __webpack_public_path__ + "static/media/moyo-new.d43f09c8.svg";